import { render, staticRenderFns } from "./Camera.vue?vue&type=template&id=31fa67ef&scoped=true&"
import script from "./Camera.vue?vue&type=script&lang=js&"
export * from "./Camera.vue?vue&type=script&lang=js&"
import style0 from "./Camera.vue?vue&type=style&index=0&id=31fa67ef&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "31fa67ef",
  null
  
)

export default component.exports